import axiosClient from './axiosClient';

const locationApi = {
  create: (data) => {
    const url = '/locations';
    return axiosClient.post(url, data);
  },
  edit: (data, locationId) => {
    const url = `/locations/${locationId}`;
    return axiosClient.put(url, data);
  },
  getAll: (params) => {
    const url = '/locations';
    return axiosClient.get(url, { params });
  },
  delete: (locationId) => {
    const url = `/locations/${locationId}`;
    return axiosClient.delete(url);
  },
  getUserLocations: () => {
    const url = '/user-locations';
    return axiosClient.get(url);
  },
};

export default locationApi;
